const initialState = {
  attendanceItems: [],
  loading: false,
};

const todayAttendanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ATTENDANCE_REQUEST":
      return { ...state, loading: true };
    case "FETCH_ATTENDANCE_SUCCESS":
      return { ...state, attendanceItems: action.payload, loading: false };
    case "FETCH_ATTENDANCE_FAILURE":
      return { ...state, loading: false };
    default:
      return state; // Always return state
  }
};


export default todayAttendanceReducer;
